/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var HorizontalFields = require('ES/widgets/HorizontalFields');
let FormUtils = require('../../../../../../utils/FormUtils');

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState: function(){
		return {show_form: false, loading: false, error_msg: null};
	},
	componentWillMount: function(){
		var self = this;
		self.radio = {
			copy_Event: function(event_id, target_sid, copylists){
				if(event_id === self.props.event.eid){
					self.setState({loading: true, error_msg: null});
				}
			},
			copy_Event_succeeded: function(event_id, new_event_id){
				if(event_id === self.props.event.eid){
					//clearing the event area, then opening the new copied event (otherwise the components wont un-mount)
					radio('Hashbang_set').broadcast('/');
					setTimeout(function(){
						radio('Hashbang_set').broadcast('/events/' + new_event_id);
					}, 100);
				}
			},
			copy_Event_failed: function(event_id, message){
				if(event_id === self.props.event.eid){
					self.setState({loading: false, error_msg: 'Failed to copy event: ' + message});
				}
			}
		};
	},
	__onSubmit: function(data){
		var event = this.props.event;
		radio('copy_Event').broadcast(event.eid, data.sid, data.copylists);
	},
	__toggleForm: esUtils.wrapPreventDefault(function(){
		this.setState({show_form: !this.state.show_form});
	}),
	render: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;
		var my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
		var thebutton = (event.is_mp_event) ? dd.div(null) : dd.p(null, dd.button({className: 'btn btn-default', onClick: this.__toggleForm}, 'Copy event'));


		return this.state.show_form ? dd.div({className: 'panel panel-default'},
			dd.div({className: 'panel-body'},
				dd.h4({className: 'section-head', style: {marginTop: 0}}, 'Copy Event'),
				ErrorAlert({message: this.state.error_msg}),
				LoadingWrap({glass: true, is_loading: this.state.loading},
					DaForm({event: event, my_speakers: my_speakers, onSubmit: this.__onSubmit, onCancel: this.__toggleForm})
				)
			)
		) : thebutton;
	}
});


var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValuesSourceVersion: function(props){
		return esUtils.getEventVersionIdentifier(props.event);
	},
	getInitialValues: function(props){
		return {
			sid: _.first(props.event.sids),
			copylists: true
		};
	},
	buildFields: function(){
		var my_speakers = this.props.my_speakers;
		var schema = {};
		if(_.keys(my_speakers).length > 1){
			schema.sid = {
				label: 'Copy to speaker',
				type: 'select',
				options: my_speakers
			};
		}
		schema.copylists = {
			label: 'Copy lists (services, contacts, actions etc...)',
			type: 'checkbox'
		};
		return schema;
	},
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var onCancel = this.props.onCancel;

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}),
			HorizontalFields.FormButtons({
				submit_btn_text: 'Copy',
				onCancel: onCancel
			})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/event_actions/CopyEvent.js